<template>
<div class="view">
  <decorate></decorate>
  <div class="main location_page">
    <div class="nav">
      <div class="left">
        <router-link
          class="front icon_back"
          :to="{
            path: '/selfInfo',
            query: {
              uid: queryData.uid,
              userId: queryData.userId,
              appId: queryData.appId,
              TopHeight: queryData.TopHeight,
            },
          }"
        ></router-link>
      </div>
      修改收货地址
    </div>
    <van-field
      autosize
      clearable
      label="用户名："
      placeholder="请输入用户名"
      v-model="username"
    />
    <van-field
      autosize
      clearable
      type="tel"
      label="手机号码："
      placeholder="+86"
      v-model="telephone"
    />
    <van-field
      autosize
      clearable
      readonly
      right-icon="arrow"
      label="所在地区："
      placeholder=""
      v-model="area"
      @click="onSelAddr()"
    />
    <van-field
      class="align_top"
      autosize
      clearable
      type="textarea"
      label="详细地址："
      placeholder="如道路、门牌号、小区、楼栋号、单元室等"
      v-model="address"
      maxlength="70"
    />
    <van-field
      autosize
      clearable
      label="邮政编码："
      placeholder="请输入邮政编码"
      v-model="mail"
    />
    <van-popup v-model="showLocat" position="bottom" get-container="body">
      <van-area
        :area-list="areaList"
        :columns-num="2"
        @confirm="setArea"
        @cancel="onAddrCancel"
      />
    </van-popup>
    <div class="submit" @click="getAddress()">提交</div>
    <p class="announce">本活动最终解释权归茄子视频所有</p>
  </div>
  </div>
</template>
    <script>
//import { mapState } from 'vuex'
import Vue from "vue";
import { Field, Area, Popup, Icon, Toast } from "vant";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import areaJson from "../plugin/arealist";
import decorate from './element/decorate'
import "../css/aside.scss";
Vue.use(Field).use(Area).use(Popup).use(Icon);
export default {
  components: {decorate},
  data: function () {
    return {
      topHeight: 0,
      areaList: areaJson,
      showLocat: false,
      username: "",
      telephone: "",
      area: "",
      address: "",
      mail: "",
      province: "",
      city: "",
    };
  },
  computed: {
    ...mapState(["homePage"]),
  },
  watch: {},
  created() {
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      addresssId: this.queryData.addresssId,
    };
    this.$store.dispatch("homePage/fetchAddressDetail", obj).then((res) => {
      this.username = res.name;
      this.telephone = res.phone;
      this.area = res.province + res.city;
      this.address = res.address;
      this.mail = res.postcode;
      this.province = res.province;
      this.city = res.city;
    });
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations([]),
    onSelAddr() {
      this.showLocat = true;
    },
    setArea(val) {
      this.area = val[0].name + val[1].name;
      this.province = val[0].name;
      this.city = val[1].name;
      this.mail = val[val.length - 1].code;
      this.showLocat = false;
    },
    onAddrCancel() {
      this.showLocat = false;
    },
    getAddress() {
      if (this.username == "") {
        Toast({
          message: "请输入用户名",
        });
        return false;
      }
      if (this.telephone == "") {
        Toast({
          message: "请输入手机号",
        });
        return false;
      }
      let phone = /^1[3456789]\d{9}$/;
      if (!phone.test(this.telephone)) {
        Toast({
          message: "请输入正确手机号",
        });
        return false;
      }
      if (this.area == "") {
        Toast({
          message: "请输入所在地区",
        });
        return false;
      }
      if (this.address == "") {
        Toast({
          message: "请输入详细地址",
        });
        return false;
      }
      if (this.mail == "") {
        Toast({
          message: "请输入邮政编码",
        });
        return false;
      }
      let obj = {
        uid: this.queryData.uid,
        userId: this.queryData.userId,
        name: this.username,
        phone: this.telephone,
        address: this.address,
        postcode: this.mail,
        province: this.province,
        city: this.city,
        addresssId: this.queryData.addresssId,
      };
      // console.log(obj)
      this.$store.dispatch("homePage/fetchEditAddress", obj).then(() => {
        this.$dialog({
          title: "提醒",
          message: "修改收货地址成功",
        }).then(() => {
          this.$router.push({
            path: "/selfInfo",
            name: "selfInfo",
            query: this.queryData,
            params: { statusTab: 1 },
          });
        });
      });
    },
  },
  mounted() {
    // const self=this;
    // this.$refs.view.scroll.on('scroll',(position)=>{
    //     self.$parent.scrollY=position.y;
    // })
  },
};
</script>
    